import CircularProgress from "@mui/material/CircularProgress";
import "./index.scss";

export const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="loading-screen">
      <div className="loading-wrapper">
        <CircularProgress sx={{ color: "var(--primary_brand, #FFD233)" }} size={48} thickness={4} />
        <p className="loading-text">{message}</p>
      </div>
    </div>
  );
};
